'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Group$() {
  this.a9I = null;
  this.c6R = null;
  this.a9I = "all";
  this.c6R = "admin";
}
export { $c_Lpresto_types$Group$ as $c_Lpresto_types$Group$ };
$p = $c_Lpresto_types$Group$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Group$;
/** @constructor */
function $h_Lpresto_types$Group$() {
}
export { $h_Lpresto_types$Group$ as $h_Lpresto_types$Group$ };
$h_Lpresto_types$Group$.prototype = $p;
$p.oZ = (function(x$0) {
  return new $c_Lpresto_types$Group($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), x$0.j(1), x$0.j(2), x$0.j(3));
});
var $d_Lpresto_types$Group$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Group$, "presto.types$Group$", ({
  a07: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$Group$ as $d_Lpresto_types$Group$ };
var $n_Lpresto_types$Group$;
function $m_Lpresto_types$Group$() {
  if ((!$n_Lpresto_types$Group$)) {
    $n_Lpresto_types$Group$ = new $c_Lpresto_types$Group$();
  }
  return $n_Lpresto_types$Group$;
}
export { $m_Lpresto_types$Group$ as $m_Lpresto_types$Group$ };
/** @constructor */
function $c_Lpresto_types$Group(id, code, name, roles) {
  this.rQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.fR = null;
  this.j9 = null;
  this.E5 = null;
  this.rQ = id;
  this.fR = code;
  this.j9 = name;
  this.E5 = roles;
}
export { $c_Lpresto_types$Group as $c_Lpresto_types$Group };
$p = $c_Lpresto_types$Group.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Group;
/** @constructor */
function $h_Lpresto_types$Group() {
}
export { $h_Lpresto_types$Group as $h_Lpresto_types$Group };
$h_Lpresto_types$Group.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Group"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.rQ;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.fR));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.j9));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.E5));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 4);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$Group)) {
    var this$1 = this.rQ;
    var b = x$0.rQ;
    if (((((this$1.e === b.e) && (this$1.f === b.f)) && (this.fR === x$0.fR)) && (this.j9 === x$0.j9))) {
      var x = this.E5;
      var x$2 = x$0.E5;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 4;
});
$p.s = (function() {
  return "Group";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.rQ;
      break;
    }
    case 1: {
      return this.fR;
      break;
    }
    case 2: {
      return this.j9;
      break;
    }
    case 3: {
      return this.E5;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.E = (function() {
  return this.j9;
});
$p.csP = (function() {
  return ($m_Lpresto_types$Group$().c6R === this.fR);
});
$p.T5 = (function() {
  return ($m_Lpresto_types$Group$().a9I === this.fR);
});
$p.H2 = (function() {
  return ("g#" + this.rQ);
});
$p.jW = (function() {
  return this.rQ;
});
function $isArrayOf_Lpresto_types$Group(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jU)));
}
export { $isArrayOf_Lpresto_types$Group as $isArrayOf_Lpresto_types$Group };
var $d_Lpresto_types$Group = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Group, "presto.types$Group", ({
  jU: 1,
  ed: 1,
  aH: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$Group as $d_Lpresto_types$Group };
//# sourceMappingURL=presto.types$-Group.js.map
